import script from "./myheader.vue?vue&type=script&setup=true&lang=js"
export * from "./myheader.vue?vue&type=script&setup=true&lang=js"

import "./myheader.vue?vue&type=style&index=0&id=39e4fabb&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e4fabb"]])

export default __exports__